import { createFileRoute } from "@tanstack/react-router";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import { ElementsProvider } from "@/components/context/ElementsProvider";
import { NewElementDndProvider } from "@/components/context/NewElementDndProvider";
import { ElementsContainer } from "@/components/ElementsContainer";
import { UserProvider } from "@/components/context/UserProvider";

export const Route = createFileRoute("/")({
  validateSearch: ({
    reset_password_token,
    change_password_token,
  }: {
    reset_password_token?: string;
    change_password_token?: string;
  }) => {
    return {
      reset_password_token: reset_password_token || undefined,
      change_password_token: change_password_token || undefined,
    };
  },
  component: RouteComponent,
});

export default function RouteComponent() {
  const { reset_password_token, change_password_token } = Route.useSearch();
  return (
    <UserProvider
      resetPasswordToken={reset_password_token}
      changePasswordToken={change_password_token}
    >
      <NewElementDndProvider>
        <DndProvider backend={HTML5Backend}>
          <ElementsProvider>
            <ElementsContainer />
          </ElementsProvider>
        </DndProvider>
      </NewElementDndProvider>
    </UserProvider>
  );
}
